<template>
  <div>
    <video ref="videoPlayer" class="video-js"></video>
  </div>
</template>

<script>
// Event Bus
import {bus} from '@/main.js';
// Library
import videojs from 'video.js'
import 'videojs-hotkeys'
import 'videojs-youtube'
import 'video.js/dist/video-js.css'
import '@/utils/videojs-thumbnails.js'

export default {
  name: "VideoPlayer",
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    subtitles: {
      type: Array,
      default() {
        return [];
      }
    },
    thumbnails: {
      type: Array|Object,
      default() {
        return [];
      }
    },
    markers: {
      type: Array,
      default() {
        return [];
      }
    },
    duration: {
      type: Number,
      default: 60
    },
    startFrom: {
      type: String
    },
  },
  data() {
    return {
      player: null,
      subtitleTrack: -1,
      
      previousTime: 0,
      currentTime: 0,
      seekStart: null,
      seekTriggered: false,
    }
  },
  watch: {
    subtitleTrack(newValue) {
      this.$emit('subtitle', newValue);
    },
    markers: {
      handler(newValue) {
        if(newValue.length > 0) {
          this.addMarkers(newValue);
        }
      },
      deep: true,
    },
    options: {
      handler(newValue) {
        if(this.player) {
          this.player.src(newValue.sources);
          this.player.load();
        }
      },
      deep: true
    },
    startFrom(newValue) {
      this.player.currentTime(parseInt(newValue));
    }
  },
  mounted() {
    this.initPlayer();
    this.initBus();
  },
  methods: {
    initPlayer() {
      this.subtitleTrack = -1;
      this.previousTime = 0;
      this.currentTime = 0;
      this.seekStart = null;
      this.seekTriggered = false;
      console.log(this.options);
      console.log(this.options.sources[0].src);
      if(this.options.sources[0].src.includes('youtu.be') || this.options.sources[0].src.includes('youtube')){
          if(this.options.sources[0].src.includes('k0ogRhgT2Kk') || this.options.sources[0].src.includes('colcIi3xUhE')){
//            this.options.sources[0].src = this.options.sources[0].src+"&cc_load_policy=1&vq=hd2160";
              this.options.youtube = {
//                ytControls: 2,
                cc_load_policy: 1,
                vq: 'hd2160'
              }
          }
      }
      console.log(this.options.sources[0].src);

      this.player = videojs(this.$refs.videoPlayer, this.options, this.onPlayerReady);
    },
    initBus() {
      bus.$on('play', this.play);
      bus.$on('pause', this.pause);
      bus.$on('setTime', this.setTime);
    },
    onPlayerReady() {
      if(this.markers.length > 0) {
        this.addMarkers(this.markers);
      }
      if(this.subtitles.length > 0) {
        this.addSubtitleButton();
      }
      if(Object.keys(this.thumbnails).length > 0) {
        this.player.thumbnails(this.thumbnails);
      }
      
      this.player.hotkeys({
        volumeStep: 0.1,
        seekStep: 5,
        enableModifiersForNumbers: false,
      });
      
      this.player.on('timeupdate', this.onTimeUpdate);
      this.player.on('playing', this.onPlaying);
      this.player.on('pause', this.onPaused);
      this.player.on('seeking', this.onSeeking);
      this.player.on('seeked', this.onSeeked);
      this.player.on('ended', this.onEnded);
      this.player.on('error', this.onError);
      this.player.on('contextmenu', this.onContextMenu);
      
      if(this.startFrom) {
        var start = parseInt(this.startFrom);
        this.player.currentTime(start);
      }
      
      this.$emit('ready');
    },
    onTimeUpdate(val) {
      this.previousTime = this.currentTime;
      this.currentTime = this.player.currentTime();
      var played = this.player.played();
      var str = "[";
      var i; 
      for (i = 0; i < played.length; i++) {
        if(i > 0)
          str += ", ";
        str += "[" + Math.floor(played.start(i)) + ", " + Math.floor(played.end(i)) + "]";
      }
      str += "]";
      this.$emit('time', {
        time: this.currentTime,
        range: str
      });
      console.log('Time ' + this.currentTime);
    },
    onPlaying(val) {
      if(!this.seekTriggered) {
        console.log('Play at ' + this.currentTime);
        this.$emit('playing', {
          time: this.currentTime,
          duration: this.player.duration()
        });
      }
    },
    onPaused(val) {
      if(!this.player.seeking()) {
        console.log('Paused at ' + this.currentTime);
        this.$emit('paused', {
          time: this.currentTime
        });
      }
    },
    onSeeking(val) {
      if(this.seekStart === null) {
        this.seekStart = this.previousTime;
      }
    },
    onSeeked(val) {
      console.log('Seek from ' + this.seekStart + ' to ' + this.currentTime);
      this.$emit('seek', {
        from: this.seekStart,
        to: this.currentTime
      });
      this.seekStart = null;
      this.seekTriggered = true; 
      setTimeout(() => { 
        this.seekTriggered = false; 
      }, 300);
    },
    onEnded(val) {
      console.log('Ended at ' + this.currentTime);
      this.$emit('ended', {
        time: this.currentTime
      });
    },
    onError(val) {
      this.$emit('error', val);
    },
    onContextMenu(val) {
      if (!this.$store.getters.isAssistant) {
        val.preventDefault();
      }
    },
    
    // Add custom plugin
    addSubtitleButton() {
      const Button = videojs.getComponent('Button')
      var SubtitleButton = videojs.extend(Button, {
        constructor(player, options) {
          Button.call(this, player, options);
          this.addClass('vjs-icon-subtitles');
          this.el().style.height = '36px';
          this.el().style.width = '36px';
          this.el().style.fontSize = '2em';
        },
        handleClick: (e) => {
          var length = this.subtitles.length;
          if(this.subtitleTrack < length - 1) {
            this.subtitleTrack++;
          } else {
            this.subtitleTrack = -1;
          }
        },
        buildCSSClass() {
          return "vjs-icon-subtitle-button vjs-control vjs-button";
        }
      });
      videojs.registerComponent('SubtitleButton', SubtitleButton)
      this.player.getChild('controlBar').addChild('SubtitleButton', {});
    },
    
    addMarkers(markers) {
      var temp = this.player.getChild('controlBar').progressControl.el().querySelector('.vjs-marker-area');
      if(temp) {
        while (temp.firstChild) {
          temp.removeChild(temp.firstChild);
        }
      }
      var markerArea = videojs.dom.createEl('div', {
        className: 'vjs-marker-area',
        innerHTML: "<div></div>"
      });
      markerArea.style.position = 'absolute';
      markerArea.style.top = '0px';
      markerArea.style.bottom = '0px';
      markerArea.style.left = '10px';
      markerArea.style.right = '10px';
      markerArea.style.display = 'relative';
      
      Array.from(markers).forEach(marker => {
        markerArea.appendChild(this.createMarkerDiv(marker, this.player));
      });
      this.player.getChild('controlBar').progressControl.el().appendChild(markerArea);
    },
    createMarkerDiv(marker) {
      var markerDiv = videojs.dom.createEl('div', {}, {
        'data-marker-key': marker.key,
        'data-marker-text': marker.text,
        'data-marker-time': marker.time,
        'data-marker-color': marker.color
      });
      markerDiv.className = `vjs-marker ${marker.class || ""}`;
      var markerDivStyle = {
        position: 'absolute',
        height: '100%',
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        'line-height': '30px',
      }
      Object.keys(markerDivStyle).forEach(key => {
        markerDiv.style[key] = markerDivStyle[key];
      });
      var markerDot = videojs.dom.createEl('div', {
        className: 'vjs-marker-dot',
        innerHTML: "<div></div>"
      });
      var markerDotStyle = {
        position: 'absolute',
        top: '40%',
        left: '0px',
        right: '0px',
        height: '20%',
        width: '4px',
        'background-color': marker.color
      }
      if(marker.timeEnd > 0) {
        markerDotStyle['width'] = '100%';
        markerDotStyle['top'] = '42.5%';
        markerDotStyle['height'] = '15%';
      }
      Object.keys(markerDotStyle).forEach(key => {
        markerDot.style[key] = markerDotStyle[key];
      });
      
      markerDiv.appendChild(markerDot);

      // hide out-of-bound markers
      const ratio = marker.time / this.duration;
      if (ratio < 0 || ratio > 1) {
        markerDiv.style.display = 'none';
      }
      
      markerDiv.style.marginLeft = (marker.time / this.duration) * 100 + '%';
      
      if(marker.timeEnd > 0) {
        markerDiv.style.marginRight = (1 - marker.timeEnd / this.duration) * 100 + '%';
      }
      
      return markerDiv;
    },
    
    dispose() {
      this.player.dispose();
      console.log('Player disposed');
    },
    play() {
      
    },
    pause() {
      if(this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
    },
    setTime(time) {
      if(this.$refs.videoPlayer) {
        this.player.currentTime(time);
      }
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.dispose()
    }
  },
}
</script>